export default __webpack_public_path__ + "static/media/footerLogo.757a478c.svg";